export class UserPresets {
  public id: number;
  public name: string;
  public customNetworks: boolean;
  public inviteThisPresetOnly: boolean;
  public scholar: boolean;
  public evaluator: boolean;
  public administrator: string;
}